import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import {
  CreatedClaim,
  ReadOnlyClaim,
  useCreateClaimDraftMutation,
  useLazyGetClaimQuery,
  useUpdateClaimMutation,
} from "../redux/apiSpecifications/apiClaims";

export const useClaims = () => {
  const [createClaimDraft] = useCreateClaimDraftMutation();
  const [getClaim] = useLazyGetClaimQuery();
  const [updateClaim] = useUpdateClaimMutation();

  const getClaimPromise = (id: number): Promise<ReadOnlyClaim | undefined> =>
    new Promise(async (resolve, reject) => {
      const response = await getClaim({
        id: id,
      });

      const getResponse = response as {
        data: ReadOnlyClaim;
      };

      if (getResponse.data) {
        resolve(getResponse.data);
      } else {
        const errorResponse = response as {
          error: FetchBaseQueryError;
        };

        reject(errorResponse.error);
      }
    });

  const createClaimDraftPromise = (
    createdClaim: CreatedClaim
  ): Promise<ReadOnlyClaim> =>
    new Promise(async (resolve, reject) => {
      const response = await createClaimDraft({
        createdClaim,
      });

      const postResponse = response as {
        data: ReadOnlyClaim;
      };

      if (postResponse.data) {
        resolve(postResponse.data);
      } else {
        const errorResponse = response as {
          error: FetchBaseQueryError;
        };

        reject(errorResponse.error);
      }
    });

  return {
    getClaimPromise,
    createClaimDraftPromise,
  };
};
